import $ from 'jquery';
import apiStatus from '../../_helpers/apiStatus';
import dialogUtil from '../../_helpers/dialogUtil';

class LoginController {
  constructor(AuthService, ClientService, $state) {
    'ngInject';
    this.name = 'login';
    this.currentYear = new Date().getFullYear();
    this.state = $state;
    this.clientService = ClientService;
    this.authService = AuthService;
  }

  $onInit() {
    //transitioning to login page, so remove all session data for current user
    sessionStorage.clear();
  }


  logIn() {
    let username = $("#m_username").val();
    let password = $("#m_password").val();

    if (username === '' || password === '') {
      dialogUtil.showErrorMessage("Please enter valid inputs");
    } else {
      this.authService.login(username, password, (result) => {
        if (result.apiStatus === apiStatus.SUCCESS) {
          this.state.go("main.home");  //Just go home, the transition auth logic will call to get the user data needed
        } else if (result.apiStatus === apiStatus.USER_LOCKED) {
          dialogUtil.showErrorMessage("Account locked due to invalid credentials. Please wait 15 minutes and try again.")
        } else {
          dialogUtil.showErrorMessage("The email/password entered is wrong. Please try again.")
        }
      })
    }
  }

  // getUserApplications() {
  //   this.authService.getSessionInfo((result) => {
  //     if (result.apiStatus !== apiStatus.SUCCESS) {
  //       dialogUtil.showErrorMessage("Error getting user application information")
  //     } else if(result.data.redirectUrl === undefined) {
  //       //didnt get redirected, just have data, so go home
  //       this.state.go("main.home");
  //     }
  //   });
  // }

  forgotPassword() {
    let email = $("#reset_pwd_email").val();
    if (email === '') {
      dialogUtil.showErrorMessage("Please enter valid inputs");
    } else {
      this.authService.forgotPassword(email, (result) => {
        if (result.apiStatus === apiStatus.SUCCESS) {
          dialogUtil.showSuccessMessage("Request is being processed. An email link with instructions will be sent when approved.");
          this._showForm("signin")
        } else {
          dialogUtil.showErrorMessage("Something went wrong. Please try again.")
        }
      })
    }
  }

  _showForm(form) {
    let cls = 'login-' + form + '-on';
    let _login = $('#kt_login');

    _login.removeClass('login-forgot-on');
    _login.removeClass('login-signin-on');
    _login.removeClass('login-signup-on');

    _login.addClass(cls);
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/login/login.controller.js